import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output
} from '@angular/core';

import { NgModel } from '@angular/forms';

import { KEYCODES } from '../../../core/constants/core.keycodes.constant.ajs';

@Component({
  selector   : '[worControlClearer]',
  styles: [ require('./control-clearer.component.scss') ],
  template: require('./control-clearer.component.html'),
})
export class ControlClearerComponent {
  @ContentChild(NgModel) model?: NgModel;

  @HostListener('keydown', [ '$event' ]) handleKeypressEvent ( event : KeyboardEvent ) : void {
    if ( event.keyCode === KEYCODES.esc ) {
      event.stopPropagation();

      this.clear();
    }
  }

  @Input('worControlClearer') isClearable = false;

  @Output() onClear: EventEmitter<any> = new EventEmitter();

  constructor ( private elementRef : ElementRef<HTMLElement> ) {}

  canClear () : boolean {
    const control = this.model?.control;

    return this.isClearable
      && !control?.disabled
      && !!control?.value;
  }

  clear () : void {
    const control = this.model?.control;

    if ( control ) {
      control.setValue(null);
      control.markAsDirty();
      control.markAsTouched();
    }

    this.onClear.emit();
  }

  // Keeps the overlaid X clear of any trailing button, such as a date picker's calendar.
  clearOffset () : number {
    const appends = this.elementRef.nativeElement.querySelectorAll<HTMLElement>(':scope > .input-group-append:not(.clear)');

    return Array.from(appends).reduce(( width, append ) => width + append.offsetWidth, 4);
  }
}
